<template> 
    <v-container class="pa-0 ma-0" fluid> 
      <v-parallax
            :height="$vuetify.breakpoint.smAndDown ? 500 : 300"
            width="100%"
            src="../assets/faq.png"
            class="mb-10"
      >
        <v-container fill-height>
          <v-row class="mx-auto">
              <v-col class="text-center">
                  <span
                      :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']"
                      class="font-weight-black"
                      data-aos="zoom-in" data-aos-duration="3000"
                      >
                      FAQ
                  </span>
              </v-col>
          </v-row>
        </v-container>
      </v-parallax>
    
      <v-row justify="center" data-aos="zoom-in" data-aos-duration="1000" style="margin-right: 10%; margin-left: 10%;">
        <v-expansion-panels accordion multiple focusable inset color="indigo lighten-4" class="mx-5">
          <v-expansion-panel light>
            <v-expansion-panel-header> Why does COLMAP generate multiple models? </v-expansion-panel-header>
            <v-expansion-panel-content class="pt-3"> 
            <p>When COLMAP cannot match all images in a dataset, it will attempt to split the dataset into two or more sub-models. A common cause is fast camera moves while collecting data. If there is not enough overlap between images, COLMAP cannot match them together. Occasionally, COLMAP can merge models together. Alternatively, Cloudcompare can be used to manually align 2 models and merge them together. However, the best likely option is to collect more images.</p>
            <p>Helpful links:
            <ul>
            <li><a href="https://colmap.github.io/faq.html#merge-disconnected-models" target="_blank" style="color:white;">https://colmap.github.io/faq.html#merge-disconnected-models</a></li>
            <li><a href="https://www.cloudcompare.org/doc/wiki/index.php?title=Align" target="_blank" style="color:white;">https://www.cloudcompare.org/doc/wiki/index.php?title=Align</a></li>
            </ul> 
            </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel
            v-for="({q,a},i) in questions"
            :key="i"
          >
            <v-expansion-panel-header> {{q}} </v-expansion-panel-header>
            <v-expansion-panel-content class="pt-3"> {{a}} </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      <v-row justify="center" class="ma-10" data-aos="zoom-in" data-aos-duration="1000">
        <span> Can't find your question? Contact us!</span>
      </v-row>
    </v-container>
</template>

<script>

export default {
  name: 'faq',

  data: () => ({
      questions: [
        {
          q: "What camera do I need for reconstruction?",
          a: "Any phone camera that can shoot in 720p is reccomended. However, any modern smartphone camera will do the trick!"
        },
        {
          q: "Is it possible to follow this manual using different softwares instead of Colmap?",
          a: "Absolutely! The photogrammetric process will be very similar using many other photogrammetric software packages, including VisualSFM, MicMac, and more. Just be aware that the technical software steps differ. Refer to the software documentation for the processing sections."
        },
      ],
  }),
};

</script>